export default __webpack_public_path__ + "assets/exclusief.9a47374d.svg";